import {
  ChameleonRequest,
  ChameleonRequestConstructorOptions,
  ChameleonRequestOptions,
} from "@repo/chameleon-request";

type NextFetchOptions = RequestInit & {
  next?: {
    revalidate?: number | false;
    tags?: string[];
    cache?: "no-cache" | "no-store" | "force-cache";
  };
};

export const configureNextServerRequest = (
  options: ChameleonRequestConstructorOptions,
) => {
  const chameleonRequest = new ChameleonRequest(options);

  const configureRequestWithNextFetchOptions = (
    method: Parameters<ChameleonRequest["configureRequest"]>[0],
  ) => {
    const configuredRequestWithMethod =
      chameleonRequest.configureRequest<NextFetchOptions>(method);

    return async <T>(
      url: string,
      nextFetchOptions?: NextFetchOptions,
      chameleonOptions?: ChameleonRequestOptions,
    ) => {
      return configuredRequestWithMethod<T>(
        url,
        nextFetchOptions,
        chameleonOptions,
      );
    };
  };

  return {
    get: configureRequestWithNextFetchOptions("GET"),
    post: configureRequestWithNextFetchOptions("POST"),
    put: configureRequestWithNextFetchOptions("PUT"),
    delete: configureRequestWithNextFetchOptions("DELETE"),
    patch: configureRequestWithNextFetchOptions("PATCH"),
  };
};
